<script setup>
import { useDeviceStore } from '@/store/deviceStore.js';
import { useOrderStore } from '@/store/orderStore.js';
import { usePlanStore } from '../../../../store/planStore';

import { computed } from 'vue';
import { onMounted } from 'vue';

const SERVER_URL = process.env.VUE_APP_URL;

const emit = defineEmits(['selected']);
const model = defineModel();

const orderStore = useOrderStore();
const deviceStore = useDeviceStore();
const planStore = usePlanStore();

const devicesByPlanType = computed(() => {
    let devices = deviceStore.devices;

    if (planStore.plan_type === 'day') {
        devices = devices.filter(device => device.plan_type === 'day');
    }

    if (planStore.plan_type === 'month') {
        devices = devices.filter(device => device.plan_type === 'month');
    }

    return devices;
});

onMounted(async () => {
    await deviceStore.fetchDevices();
});

function selectDevice(device) {
    // model.value = device.id;
    emit('selected', device);
}
</script>

<template>
    <div class="flex gap-4 w-full">
        <div 
            v-for="device in devicesByPlanType" 
            :key="device.id"
            class="group/item border-2 w-40 rounded-lg border-sky-400 p-4 cursor-pointer flex flex-col items-center hover:bg-sky-400"
            :class="{ 'bg-sky-400': model === device.id }"
            @click="selectDevice(device)"
        >
            <img v-if="device.type == 1" :src="`${SERVER_URL}/image/plan-device-type-1.png`" alt="" class="h-16 mb-2">
            <img v-if="device.type == 2" :src="`${SERVER_URL}/image/plan-device-type-2.png`" alt="" class="h-16 mb-2">

            <h5 
                class="text-black group-hover/item:text-white"
                :class="{ 'text-white': model === device.id }"
            >{{ device.name }}</h5>

            <div v-if="device.note" class="group/note relative">
                <div class="hidden group-hover/note:block w-36 text-center absolute z-10 bottom-7 -left-15 bg-white p-2 rounded-md shadow-sm" v-html="device.note"></div>
                <svg 
                    class="group-hover/item:fill-white" 
                    :class="{ 'fill-white': model === device.id }"
                    xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                    fill="#7DD3FC"
                >
                    <path
                        d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
                </svg>
            </div>
        </div>
    </div>
</template>